 import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api"; 

export const add_friend = createAsyncThunk(
    'chat/add_friend',
    async(info, { rejectWithValue,fulfillWithValue }) => {
        try {
            const {data} = await api.post('/chat/customer/add-customer-friend',info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data ?? { error: error.message })
        }
    }
)
// End Method

export const get_friends = createAsyncThunk(
    'chat/get_friends',
    async(_, { rejectWithValue,fulfillWithValue }) => {
        try {
            const {data} = await api.get('/chat/customer/get-friends')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const get_sellers = createAsyncThunk(
    'chat/get_sellers',
    async(_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.get('/chat/customer/get-sellers')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data ?? { error: error.message })
        }
    }
)
// End Method

export const send_message = createAsyncThunk(
    'chat/send_message',
    async(info, { rejectWithValue,fulfillWithValue }) => {
        try {
            const {data} = await api.post('/chat/customer/send-message-to-seller',info)
             return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

 


export const chatReducer = createSlice({
    name: 'chat',
    initialState:{
        my_friends: [],
        fb_messages : [],
        currentFd: "",
        sellers: [],
        sellersLoading: false,
        sellersError: '',
        addFriendLoading: false,
        errorMessage : '',
        successMessage: '', 
    },
    reducers : {

        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        updateMessage: (state, {payload}) => {
            state.fb_messages = [...state.fb_messages, payload]
        }
  
    },
    extraReducers: (builder) => {
        builder 
        .addCase(get_friends.fulfilled, (state, { payload }) => {
            state.my_friends = payload.myFriends;
        })
        .addCase(add_friend.fulfilled, (state, { payload }) => {
            state.fb_messages = payload.messages;
            state.currentFd = payload.currentFd;
            state.my_friends = payload.MyFriends;
            state.addFriendLoading = false;
        })
        .addCase(add_friend.pending, (state) => {
            state.addFriendLoading = true;
        })
        .addCase(add_friend.rejected, (state, { payload }) => {
            state.addFriendLoading = false;
            state.errorMessage = payload?.error || 'Unable to add seller to chat';
        })
        .addCase(get_sellers.pending, (state) => {
            state.sellersLoading = true;
            state.sellersError = '';
        })
        .addCase(get_sellers.fulfilled, (state, { payload }) => {
            state.sellers = payload.sellers;
            state.sellersLoading = false;
        })
        .addCase(get_sellers.rejected, (state, { payload }) => {
            state.sellersLoading = false;
            state.sellersError = payload?.error || 'Unable to load sellers';
        })
        .addCase(send_message.fulfilled, (state, { payload }) => { 
            let tempFriends = state.my_friends
            let index = tempFriends.findIndex(f => f.fdId === payload.message.receverId)
            while (index > 0) {
                let temp = tempFriends[index]
                tempFriends[index] = tempFriends[index - 1]
                tempFriends[index - 1] = temp
                index--
            }            
            state.my_friends = tempFriends;
            state.fb_messages = [...state.fb_messages, payload.message];
            state.successMessage = 'Message Send Success';
        })

       
    }
})
export const {messageClear,updateMessage} = chatReducer.actions
export default chatReducer.reducer